export default __webpack_public_path__ + "static/media/ayeshababur.34bc4620.jpg";